export const CREDIT_APP_SEARCH_MERGE_DEAL = 'CREDIT_APP_SEARCH_MERGE_DEAL';
export const CREDIT_APP_SEARCH_OPEN_SLIDEOUT = 'CREDIT_APP_SEARCH_OPEN_SLIDEOUT';
export const CREDIT_APP_SEARCH_CLOSE_SLIDEOUT = 'CREDIT_APP_SEARCH_CLOSE_SLIDEOUT';
export const CREDIT_APP_SEARCH_SHOW_SAVE_REMINDER = 'CREDIT_APP_SEARCH_SHOW_SAVE_REMINDER';
export const CREDIT_APP_SEARCH_HIDE_SAVE_REMINDER = 'CREDIT_APP_SEARCH_HIDE_SAVE_REMINDER';
